import { Layout as AntLayout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const { Content } = AntLayout;

const Layout = () => {
  const location = useLocation();
  const showHeader = location.pathname.startsWith('/content')
    || location.pathname.startsWith('/timedPublish');

  return (
    <AntLayout style={{ height: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <AntLayout style={{ height: '100vh', overflow: 'hidden' }}>
        {showHeader && <Header />}
        <Content style={{ flex: 1, overflow: 'hidden', background: '#f5f7fa', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <div className={`app-scroll${showHeader ? '' : ' app-scroll--no-header'}`}>
            <Outlet />
          </div>
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;

